import { __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import s from './FlagSwitcher.scss';
var FlagSwitcher = /** @class */ (function (_super) {
    __extends(FlagSwitcher, _super);
    function FlagSwitcher() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isVisible: _this.props.show || false,
        };
        _this.onAddNew = function () {
            var _a;
            var setFlags = _this.props.setFlags;
            var val = _this.inputNode && _this.inputNode.value;
            if (!val) {
                return;
            }
            setFlags((_a = {}, _a[val] = true, _a));
        };
        _this.onRemove = function (key) {
            var _a;
            var setFlags = _this.props.setFlags;
            setFlags((_a = {}, _a[key] = false, _a));
        };
        _this.onKeyDown = function (event) {
            var flags = _this.props.flags;
            if (event.repeat) {
                return;
            }
            if (event.altKey &&
                event.ctrlKey &&
                (event.key === 'F2' || event.key === '`')) {
                _this.setState({ isVisible: true });
                if (flags.includes('bi_xray')) {
                    var links = document.querySelectorAll('button,a');
                    for (var i = 0; i < links.length; i++) {
                        var el = links[i];
                        if (!el.hasAttribute('data-bidata')) {
                            el.style.backgroundColor = 'rgba(255,0,0,.5)';
                        }
                        else {
                            // will improve this later to use proper tooltip
                            el.setAttribute('title', el.dataset.bidata || '');
                            el.style.backgroundColor = 'rgba(0,255,0,.5)';
                        }
                    }
                }
            }
        };
        _this.onHide = function () {
            _this.setState({ isVisible: false });
            _this.props.onHide && _this.props.onHide();
        };
        return _this;
    }
    FlagSwitcher.prototype.componentDidMount = function () {
        window.addEventListener('keydown', this.onKeyDown);
    };
    FlagSwitcher.prototype.componentWillUnmount = function () {
        window.removeEventListener('keydown', this.onKeyDown);
    };
    FlagSwitcher.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.show !== this.props.show) {
            this.setState({ isVisible: !!this.props.show });
        }
    };
    FlagSwitcher.prototype.render = function () {
        var _this = this;
        var isVisible = this.state.isVisible;
        if (!isVisible) {
            return null;
        }
        var flags = this.props.flags;
        return (React.createElement("div", { className: classnames(s['root'], this.props.show && s['showing']) },
            React.createElement("div", { className: s['hide'], onClick: this.onHide }, "x"),
            React.createElement("div", { className: s['header'] }, "Flags"),
            React.createElement("ul", { className: s['list'] },
                flags.map(function (flag) { return (React.createElement("li", { className: s['list-item'], key: flag },
                    React.createElement("span", null, flag),
                    React.createElement("button", { className: s['remove'], onClick: function () { return _this.onRemove(flag); } }, "x"))); }),
                React.createElement("li", { className: s['list-item'] },
                    React.createElement(TextInput, { id: "flag-switcher-input", className: s['input'], ref: function (node) {
                            _this.inputNode = node;
                        }, onKeyUp: function (ev) { return ev.key === 'Enter' && _this.onAddNew(); }, label: 'Flag', value: '', isLabelHidden: true, autoFocus: true }),
                    React.createElement("button", { className: s['add'], onClick: this.onAddNew }, "Add new")))));
    };
    return FlagSwitcher;
}(React.Component));
export { FlagSwitcher };
export default FlagSwitcher;
//# sourceMappingURL=FlagSwitcher.js.map